<template>
	<button class="button" type="submit">
		<slot/>
	</button>
</template>

<script>
export default {
	props: {

	}
};
</script>

<style lang="scss" scoped>
.button {
	border: 0px;
	appearance: none;
	outline: none;
	width: 100%;
	height: 50px;
	font-size: 12px;
	background: #1A1919;
	color: $white1;
	text-transform: uppercase;
	font-weight: 300;
	letter-spacing: 1px;
	cursor: pointer;
}
</style>
